var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.6667C12.5066 21.6667 9.66663 18.8267 9.66663 15.3334V8.00008C9.66663 4.50675 12.5066 1.66675 16 1.66675C19.4933 1.66675 22.3333 4.50675 22.3333 8.00008V15.3334C22.3333 18.8267 19.4933 21.6667 16 21.6667ZM16 3.66675C13.6133 3.66675 11.6666 5.61341 11.6666 8.00008V15.3334C11.6666 17.7201 13.6133 19.6667 16 19.6667C18.3866 19.6667 20.3333 17.7201 20.3333 15.3334V8.00008C20.3333 5.61341 18.3866 3.66675 16 3.66675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.3334C9.82671 26.3334 4.80005 21.3067 4.80005 15.1334V12.8667C4.80005 12.32 5.25338 11.8667 5.80005 11.8667C6.34672 11.8667 6.80005 12.32 6.80005 12.8667V15.1334C6.80005 20.2 10.9334 24.3334 16 24.3334C21.0667 24.3334 25.2 20.2 25.2 15.1334V12.8667C25.2 12.32 25.6534 11.8667 26.2 11.8667C26.7467 11.8667 27.2 12.32 27.2 12.8667V15.1334C27.2 21.3067 22.1734 26.3334 16 26.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.3333C15.4533 30.3333 15 29.8799 15 29.3333V25.3333C15 24.7866 15.4533 24.3333 16 24.3333C16.5467 24.3333 17 24.7866 17 25.3333V29.3333C17 29.8799 16.5467 30.3333 16 30.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.fc0cba33d96ac5c576a32dca73fc2ae4.svg";
export { ForwardRef as ReactComponent };